import { useState, useEffect, useRef } from "react";
 
 
import Config from "../Config";

function MediaLink(props)
{
    const [link, setLink] = useState(props.link);
    const [title, setTitle] = useState(props.title);

    const [status, setStatus] = useState(0);


    const toBlob = (byteCharacters, contentType='', sliceSize=512) => {
        
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
          
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }




    const goDownload = (e) => {

        setStatus(1);


        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch(  link , {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         //.then(res => res.bytes() )
         .then(res => res.blob() )
         .then(res => { 
                   
                        props.mainView.setProgress(-1);   
                        setStatus(0);
                            
                        const blob = new Blob( [res] , {type:  '' });
                        
                        const blobUrl = URL.createObjectURL(blob);                   

                        var anchor = document.createElement('a');
                        anchor.href = blobUrl;
                        anchor.target = '_blank';
                        anchor.download = title;
                        anchor.click();

                   
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }


    if(status == 1)
    {
        return <span className="link_color"  >
            &nbsp; &nbsp;  czekaj...  &nbsp; &nbsp; 
        </span>
    }


    return <span className="link_color" onClick={goDownload}>
        &nbsp; &nbsp; {title}   &nbsp; &nbsp; 
    </span>

}


export default MediaLink;